const steps = [
  {
    num: '1',
    title: '주방 사진 찍기',
    desc: '설치될 공간의 사진을 찍습니다',
  },
  {
    num: '2',
    title: '공간 정보 입력',
    desc: '크기와 원하는 구성을 입력합니다',
  },
  {
    num: '3',
    title: '디자인과 견적 수령',
    desc: '3일 안으로 디자이너의 견적서를 받아보세요\n(영업일 기준)',
  },
];

export default function HowToSection() {
  return (
    <section className="w-full bg-white py-20 px-6">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row lg:items-start lg:justify-between gap-10 mb-14">
          <div>
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 leading-snug">
              대구·경북에서 가장 합리적으로
              <br />
              싱크대·주방가구 교체하는 방법
            </h2>
            <a
              href="/kitchendesignprice"
              className="inline-flex items-center justify-center mt-6 px-8 py-3 bg-yellow-400 text-gray-900 font-bold text-sm rounded-md hover:bg-yellow-500 transition-colors whitespace-nowrap cursor-pointer"
            >
              무료 견적 신청하기
            </a>
          </div>
          <div className="lg:w-64 flex-shrink-0">
            <img
              src="https://cdn.imweb.me/thumbnail/20240828/347215d168705.png"
              alt="주방 가구 신청 안내"
              className="w-full h-auto object-contain"
            />
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-14">
          {steps.map((step) => (
            <div
              key={step.num}
              className="bg-yellow-400 rounded-lg p-8"
            >
              <p className="text-3xl font-black text-gray-900 mb-2">{step.num}</p>
              <h3 className="text-lg font-bold text-gray-900 mb-2">{step.title}</h3>
              <p className="text-sm text-gray-800 whitespace-pre-line leading-relaxed">{step.desc}</p>
            </div>
          ))}
        </div>

        {/* 영상 */}
        <div className="w-full aspect-video rounded-lg overflow-hidden">
          <video
            src="https://storage.readdy-site.link/project_files/65a4cfe2-101f-4bfd-b4c1-931a3de7c027/39303116-3b11-46bc-9ac2-3ba50de8b19a_Camera_movement_modern_202604141710.mp4?v=e834d5f4363f9b2f8a59097b7013d335"
            className="w-full h-full object-cover"
            controls
            playsInline
            aria-label="대구싱크대 키친스 - 주방 리모델링 가이드 영상"
          />
        </div>
      </div>
    </section>
  );
}
